<template>
  <transition name="landscape-fade">
    <div v-if="isLandscape" class="landscape-tip">
      <div class="tip-content">
        <div class="tip-icon">
          <div class="tip-icon-img"></div>
        </div>
        <div class="tip-text">{{ letter.landscapeTip2 }}</div>
        <div class="tip-close" @click="closeTip"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LandscapeTip',
  data() {
    return {
      isLandscape: false,
      orientationTimer: null
    };
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  methods: {
    getDevice() {
      let userAgent = window.navigator.userAgent;
      let ua = userAgent.toLowerCase();
      let platform = {
        isAndroid: function () {
          return ua.indexOf('android') > -1;
        },
        isIOS: function () {
          let NPlatform = navigator.platform;
          return (
            ua.indexOf('iphone') > -1 ||
            /iPad|iPhone|iPod/gi.test(NPlatform) ||
            (NPlatform === 'MacIntel' &&
              navigator.maxTouchPoints > 1 &&
              !window.MSStream)
          );
        },
        isWinPhone: function () {
          return !!navigator.userAgent.match(/Windows Phone/i);
        },
        isIpad: function () {
          return ua.indexOf('ipad') > -1;
        },
        isPhone: function () {
          return (
            this.isAndroid() ||
            this.isIOS() ||
            this.isWinPhone() ||
            this.isIpad()
          );
        },
        isElectron: function () {
          return ua.indexOf('electron') > -1;
        }
      };
      return platform;
    },
    checkIsLandscape() {
      const w = window.innerWidth;
      const h = window.innerHeight;
      return w > 0 && h > 0 && w > h * 1.3;
    },
    isMobileLandscape() {
      const device = this.getDevice();
      return device.isPhone() && this.checkIsLandscape();
    },
    // 检测屏幕方向
    checkOrientation() {
      this.isLandscape = this.isMobileLandscape();
    },
    // 监听屏幕方向变化
    handleOrientationChange() {
      // 清除之前的定时器，避免重复执行
      if (this.orientationTimer !== null) {
        clearTimeout(this.orientationTimer);
      }
      // 延迟一下，等待屏幕方向变化完成
      this.orientationTimer = setTimeout(() => {
        this.checkOrientation();
        this.orientationTimer = null;
      }, 100);
    },
    // 监听窗口大小变化（作为备用方案）
    handleResize() {
      this.checkOrientation();
    },
    closeTip() {
      this.isLandscape = false;
    }
  },
  mounted() {
    this.checkOrientation();
    // 监听屏幕方向变化事件
    window.addEventListener('orientationchange', this.handleOrientationChange);
    // 监听窗口大小变化（某些浏览器可能不支持 orientationchange）
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 清理定时器，防止组件卸载后访问已销毁的响应式变量
    if (this.orientationTimer !== null) {
      clearTimeout(this.orientationTimer);
      this.orientationTimer = null;
    }
    window.removeEventListener(
      'orientationchange',
      this.handleOrientationChange
    );
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
.landscape-tip {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.tip-content {
  position: relative;
  background: rgba(34, 34, 34, 0.95);
  border-radius: 12px;
  padding: 24px 32px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  max-width: 80%;
}

.tip-icon {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tip-icon div {
  width: 64px;
  height: 64px;
  background: url('~@assets/image/officialTopupNew/common/iphone.png') no-repeat;
  background-size: contain;
  animation: rotate 2s ease-in-out infinite;
}

.tip-text {
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
}

.tip-close {
  position: absolute;
  top: -30px;
  right: -30px;
  width: 24px;
  height: 24px;
  background: url('~@assets/image/officialTopupNew/common/close-land.png') no-repeat;
  background-size: contain;
}

@keyframes rotate {
  0%,
  100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-90deg);
  }
  75% {
    transform: rotate(90deg);
  }
}

.landscape-fade-enter-active,
.landscape-fade-leave-active {
  transition: opacity 0.3s ease;
}

.landscape-fade-enter,
.landscape-fade-leave-to {
  opacity: 0;
}
</style>
